import React from "react";

import { clsx } from "clsx";

import HeroButton from "./HeroButton";
import { Image } from "../../Image/Image";

const Wrapper = (props: any) => (
  <div {...props} className={clsx(props.className, "w-1/2 font-display")} />
);

const ImageWrapper = (props: any) => (
  <div
    {...props}
    className={clsx(props.className, "sm:aspect-square relative aspect-4-5")}
  />
);

const InnerImageWrapper = (props: any) => (
  <div {...props} className={clsx(props.className, "inset-0 absolute")} />
);

const ButtonWrapper = (props: any) => (
  <div
    {...props}
    className={clsx(
      props.className,
      "inset-0 pointer-events-none absolute flex h-full w-full items-end justify-center md:items-center",
    )}
  />
);

const HeroImage = ({ image, onClickImage, imageLink, link }) => {
  return (
    <Wrapper>
      <ImageWrapper>
        <InnerImageWrapper>
          {link &&
            link?.url &&
            link?.url !== "" &&
            link?.title &&
            link?.title !== "" && (
              <ButtonWrapper>
                <HeroButton link={link.url}>{link.title}</HeroButton>
              </ButtonWrapper>
            )}
          <Image
            image={image}
            alt={image.alt}
            onClick={onClickImage}
            imageLink={imageLink}
            fullHeight
            critical={true}
            staticImage={true}
          />
        </InnerImageWrapper>
      </ImageWrapper>
      {link &&
        link?.url &&
        link?.url !== "" &&
        link?.title &&
        link?.title !== "" && (
          <HeroButton link={link?.url} mobile>
            {link?.title}
          </HeroButton>
        )}
    </Wrapper>
  );
};

export default HeroImage;
